import {RedTigerWidgetDefaultBox} from './red-tiger-widget.default.box';

export const RedTigerWidgetBox = RedTigerWidgetDefaultBox;
